document.addEventListener('DOMContentLoaded', function () {
  //console.log('wheelio show js loaded');

  function initWheelioTrigger() {
    // 这里可以写多个选择器，防止类名变化
    var triggerBtn =
      document.querySelector('.trigger-button-holder') ||
      document.querySelector('#wlo-trigger-button-holder');

    // 还没插入就 200ms 后再试
    if (!triggerBtn) {
      setTimeout(initWheelioTrigger, 200);
      return;
    }

    //console.log('wheelio trigger button found', triggerBtn);

    // 初始要显示
    triggerBtn.classList.remove('wl-trigger-hidden');

    var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var ticking = false;

    window.addEventListener('scroll', function () {
      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;

      if (!ticking) {
        window.requestAnimationFrame(function () {
          // 向下滚动 → 隐藏按钮
          if (currentY > lastScrollY + 5) {
            triggerBtn.classList.add('wl-trigger-hidden');
          }
          // 向上滚动 → 显示按钮
          else if (currentY < lastScrollY - 5) {
            triggerBtn.classList.remove('wl-trigger-hidden');
          }

          lastScrollY = currentY;
          ticking = false;
        });

        ticking = true;
      }
    });
  }

  // 开始轮询等待按钮出现
  initWheelioTrigger();
});
